import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class RelationLabels extends ConfigNode
  @className = 'RelationLabels'

  constructor: ->
    super('relationLabels')

  update: (map) ->
    @set('value', map, { dataType: 'json' })
    @save()

  @load: ->
    super('relationLabels', @)

export default RelationLabels
